import Vue from 'vue';
import axios from 'axios';
import VueI18n from '../plugins/i18n';
import VueRouter from '../router';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.interceptors.request.use(async request => {
  const token = null;

  if (token) {
    request.headers.common.Authorization = `Bearer ${token}`;
  }

  return request;
});

axios.interceptors.response.use(
  response => response,
  error => {
    console.log(error.response);
    if (error.response.status === 403) {
      Vue.swal({
        html:`<b><p style = ' color: #1c4c91;'> ${ VueI18n.t(error.response.data.message)}</p></b> <br>`,
        width: error.response.data.width,
        confirmButtonText: VueI18n.t(error.response.data.confirm_button),
        confirmButtonColor: '#1C4C91',
        background: 'center #EFF3F2 url(https://jwperfectmatch.com/storage/image/banner-profile-subscribe.webp) no-repeat'
      }).then(result =>{
          if (result.value) {
            VueRouter.push('../subscriptions');
          }
        });

    }

    return Promise.reject(error);
  }
);

Vue.prototype.axios = axios;
Vue.prototype.$http = axios;

window.axios = axios;
